import LcFetch from "lib/shared/fetch";

export default class PayAttemptPoller {
  constructor() {
    this.pollFrequencyInMillis = 1000;
    this.maxRequests = 900; // 1000ms * 900 = 15 minutes limit (not accounting for response times)
    this.requestsCount = 0;
    this.errorsCount = 0;
  }

  getFinalDestination(payAttempt) {
    if (payAttempt.origin === "upgrade") {
      return "/account";
    }
    return "/close_registration";
  }

  incrementRequests() {
    this.requestsCount += 1;
  }

  incrementErrors() {
    this.errorsCount += 1;
  }

  isRequestLimitExceeded() {
    return this.requestsCount > this.maxRequests;
  }

  async poll(payAttempt, onSuccess, onFatal) {
    if (this.isRequestLimitExceeded()) {
      onFatal();
      return;
    }

    this.incrementRequests();

    let delayFactor = 1;
    try {
      const response = await LcFetch(payAttempt.url);
      if (response.ok) {
        const data = await response.json();
        const attempt = data.pay_attempt;
        switch (attempt.state) {
          case "succeeded":
            onSuccess(this.getFinalDestination(attempt));
            return;

          case "failed":
            onFatal();
            return;

          default:
            break;
        }
      } else {
        delayFactor = 3; // Poll again with a longer delay to give server time to recover
        this.incrementErrors();
      }
    } catch (_error) {
      delayFactor = 3; // Poll again with a longer delay to give server time to recover
      this.incrementErrors();
    }

    this.pollLater(
      payAttempt,
      onSuccess,
      onFatal,
      delayFactor * this.pollFrequencyInMillis
    );
  }

  pollLater(payAttempt, onSuccess, onFatal, delayInMillis) {
    setTimeout(() => {
      this.poll(payAttempt, onSuccess, onFatal);
    }, delayInMillis || this.pollFrequencyInMillis);
  }
}
